import React, { FC } from 'react'
import { Box } from '@mui/system'
import { useNavigate } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import { EntityHeader, HasSidebarLayout } from 'src/components'
import { PromptForm } from 'src/components/forms/prompt'
import { useNewPromptRequest } from 'src/hooks/api'
import { useAddPopupMessage } from 'src/hooks/ui'
import { PromptInput } from 'src/api'
import { Entities } from 'src/enums'

const PromptNew: FC = () => {
  document.title = 'CLīMIT Admin Panel - New prompt'
  const navigate = useNavigate()
  const addMessage = useAddPopupMessage()
  const queryClient = useQueryClient()
  const request = useNewPromptRequest()

  const onSubmit = (payload: PromptInput) => {
    request.mutate(payload, {
      onSuccess: () => {
        queryClient.invalidateQueries([Entities.Prompts])
        addMessage({ text: 'Prompt created successfully', type: 'success' })
        navigate('/prompts')
      },
      onError: ({ message: text }) => addMessage({ text, type: 'error' })
    })
  }

  return (
    <HasSidebarLayout>
      <EntityHeader title="New prompt" onBack={() => navigate('/prompts')} />
      <Box width="700px" maxWidth="100%" mt={2}>
        <PromptForm onSubmit={onSubmit} isLoading={request.isLoading} submitLabel="Create" />
      </Box>
    </HasSidebarLayout>
  )
}

export default PromptNew
